<div class="card-remove-wrapper">
    <div class="card-remove-wrapper2">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="text-center">
                    Are you sure you want to delete this item?
                </h2>
            </div>
           <div class="col-6 text-center mt-4">
            <button  type="button" class="custom-btn btn-md-rounded btn-no" (click)="onClose('no')">No</button>
           </div>
           <div class="col-6 text-center mt-4">
            <button  type="button" class="custom-btn btn-md-rounded btn-yes" (click)="onClose('yes')">Yes</button>
           </div>
        </div>
    </div>
</div>
</div>
